import React from 'react'

const ArchiveModalIcon = () => {
    return (
        <svg width="80" height="81" viewBox="0 0 80 81" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="0.5" width="80" height="80" rx="40" fill="#EBEBEB" />
            <path d="M60.25 20.75H19.75C18.5074 20.75 17.5 21.7574 17.5 23V29.75C17.5 30.9926 18.5074 32 19.75 32H60.25C61.4926 32 62.5 30.9926 62.5 29.75V23C62.5 21.7574 61.4926 20.75 60.25 20.75Z" stroke="black" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M22 32.0078V56.7578C22 57.9513 22.4741 59.0959 23.318 59.9398C24.1619 60.7837 25.3065 61.2578 26.5 61.2578H53.5C54.6935 61.2578 55.8381 60.7837 56.682 59.9398C57.5259 59.0959 58 57.9513 58 56.7578V32.0078" stroke="black" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M35.5 41H44.5" stroke="black" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default ArchiveModalIcon
